<template>
	<div class="comp">
		<el-dialog :title="''" :before-close='addShopStateClose' :visible.sync="dialogState" width="1400px" top="3vh">

			<div style="padding-top:20px;">
				<div style="display: inline-flex;width:300px;">
					<div style="width:80px;line-height: 40px;padding-left: 10px;">关键字：</div>
					<el-input v-model="params.keyword" @keyup.enter.native="clickSearch" clearable></el-input>
				</div>
				<div style="display: inline-block;margin-left: 30px;">
					<el-button type="success" @click="clickSearch">搜索</el-button>
				</div>
			</div>
			<el-table :data="petgift" style="width: 100%">
				<el-table-column label="名称" prop="title">
				</el-table-column>
				<el-table-column prop="pet_grade" label="分类">
					<template slot-scope="scope">
						<span> {{scope.row.category_info.name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="级别">
					<template slot-scope="scope">
						<span> {{scope.row.gift_bag_level.title}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="pet_sex" label="包含商品">
					<!-- <template slot-scope="scope">
						<span> {{scope.row.gift_bag_plan_items.goods.length}}</span>
					</template> -->
				</el-table-column>
				<!-- <el-table-column prop="sale_price" label="包含洗美卡">
					<template slot-scope="scope">
						<span> {{scope.row.gift_bag_plan_items.card.length}}</span>
					</template>
				</el-table-column> -->
				<el-table-column label="价格">
					<template slot-scope="scope">
						<span> {{scope.row.gift_bag_plans[0].price}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<div v-for="(item,index) in scope.row.gift_bag_plans" :key='index'>
							<span>{{item.name}}</span>	<el-button type="text" size="small" @click='choose(scope.row,item)'>选择
						</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<page :total="total" :page="params.pageIndex" :pageSize='params.pageSize' @change="changePage"></page>
		</el-dialog>
	</div>
</template>
<script>
	import page from "../../components/page.vue"
	import {
		getPetGiftList,
	} from '../../api/program.js'
	export default {
		components: {
			page
		},
		data() {
			return {
				dialogState: true,
				search: {
					keyword: ''
				},

				params: {
					pageSize: 10,
					pageIndex: 1,
					keyword: '',
				},
				allshopId: '', //所有商品id  zt写
				allType: false, //默认进入标记 zt写
				total: 0,
				petgift: [],
			}
		},
		computed: {
			curShopId() {
				return this.$store.state.shopId;
			},
		},


		mounted() {
			this.getPetGiftList();
		},
		methods: {
			//向父组件发射关闭弹框
			addShopStateClose(done) {
				done()
				this.$emit("closeOn", false);
			},
			// 搜索关键字
			clickSearch() {
				this.params.pageIndex = 1;
				this.getPetGiftList();
			},
			
			// 分页
			changePage(num) {
				this.params.pageIndex = num;
				this.getPetGiftList();
			},
			getPetGiftList() {
				getPetGiftList(this.params).then(res => {
					if (res.code == 0) {
						console.log(res.data.data)
						this.petgift = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			choose(row,skuitem) {
				this.$emit('submit', {data:row,skuitem:skuitem})
			}

		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.navLine {
			display: flex;
			font-size: 18px;
			border-bottom: 1px solid #DDDDDD;

			.label {
				color: #1A1A1A;
				font-weight: bold;
				padding: 10px 10px 10px 47px;
			}

			.navItem {
				color: #555555;
				margin: 0 20px;
				padding: 10px 0;
				cursor: pointer;

				&.active {
					border-bottom: 2px solid #FDD000;
				}
			}
		}

		.labelBox {
			display: flex;
			margin: 2px 0 0;

			.label {
				font-size: 14px;
				font-weight: bolder;
				flex-shrink: 0;
				line-height: 25px;
				display: inline-block;
				width: 85px;
				text-align: right;
			}

			.labelItemBox {
				display: flex;
				flex-wrap: wrap;
				padding-left: 10px;
				box-sizing: border-box;

				.labelItem {
					font-size: 14px;
					padding: 5px 5px 3px;
					border-radius: 2px;
					margin: 2px 3px;
					color: #555555;
					cursor: pointer;

					&.active {
						background-color: #FDD000;
					}

					&:hover {
						background-color: #FDD000;
					}
				}
			}
		}

		::v-deep.el-dialog__body {
			padding-top: 0;
		}
	}
</style>
